import { BookOpen } from "lucide-react";

export const DictionaryHero = () => {
  return (
    <div className="mb-12 text-center space-y-6">
      <div className="flex justify-center mb-4">
        <div className="p-4 rounded-2xl bg-primary/10">
          <BookOpen className="h-12 w-12 text-primary" />
        </div>
      </div>
      <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight animate-slide-down">
        Dicionário Imobiliário
      </h1>
      <p className="text-lg text-muted-foreground max-w-3xl mx-auto leading-relaxed animate-slide-up stagger-1">
        Consulte definições e termos do mercado imobiliário brasileiro.
        Construção, documentação, direito e muito mais.
      </p>
    </div>
  );
};
